var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import IdentityPlugin from '@liquid-state/iwa-identity';
import Ubiquity from './client';
var UbiquityPlugin = /** @class */ (function () {
    function UbiquityPlugin(options) {
        this.options = options;
        this.key = UbiquityPlugin.key;
    }
    UbiquityPlugin.configure = function (customise) {
        var defaultOptions = { useAls: false, useIdentity: true };
        var options = customise ? customise(defaultOptions) : defaultOptions;
        return new UbiquityPlugin(options);
    };
    UbiquityPlugin.prototype.use = function (app) {
        return __awaiter(this, void 0, void 0, function () {
            var clientOptions, _a, _b, appToken, companyToken, baseUrl, baseS3Url;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        clientOptions = this.options;
                        clientOptions.identity = {};
                        if (!this.options.useAls) return [3 /*break*/, 2];
                        _a = clientOptions;
                        return [4 /*yield*/, app.alsProvider.result()];
                    case 1:
                        _a.als = _c.sent();
                        _c.label = 2;
                    case 2:
                        if (this.options.useIdentity && !this.options.jwt) {
                            clientOptions.identity.identityProvider = app.use(IdentityPlugin).forService('ubiquity');
                        }
                        else if (this.options.jwt) {
                            clientOptions.identity.jwt = this.options.jwt;
                        }
                        return [4 /*yield*/, app.configuration('app_token', 'company_token', 'UBIQUITY_BASE_URL', 'UBIQUITY_BASE_S3_URL')];
                    case 3:
                        _b = _c.sent(), appToken = _b.app_token, companyToken = _b.company_token, baseUrl = _b.UBIQUITY_BASE_URL, baseS3Url = _b.UBIQUITY_BASE_S3_URL;
                        clientOptions.baseUrl = clientOptions.baseUrl || baseUrl;
                        clientOptions.baseS3Url = clientOptions.baseS3Url || baseS3Url;
                        return [2 /*return*/, new Ubiquity(this.options.companyToken || companyToken, this.options.appToken || appToken, clientOptions)];
                }
            });
        });
    };
    UbiquityPlugin.key = 'ubiquity';
    return UbiquityPlugin;
}());
export default UbiquityPlugin;
//# sourceMappingURL=plugin.js.map